import { Mail, Search } from 'lucide-react';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import SCIsOverall from '../../../components/Monitoring/SCIs/SCIsOverall/SCIsOverall.module';
import type { RootState } from '../../../store/store';
import { resolveDefaultTemplateId } from '../../../utils/sciMailWindows';
import SciMailTemplates from '../components/SciMailTemplates';
import { rentMailTemplates } from './rentMailTemplates';

type TabId = 'identify' | 'mail-templates';

function SCIsRent() {
  const [activeTab, setActiveTab] = useState<TabId>('identify');
  const company = useSelector((state: RootState) => state.auth.company);
  const companyDefaultId = useMemo(
    () => resolveDefaultTemplateId(company?.brandingSettings?.sciMailWindows, 'rent'),
    [company?.brandingSettings?.sciMailWindows],
  );

  const tabs = useMemo(() => ([
    { id: 'identify' as const, title: 'Identifier les SCI présentes dans la copropriété', icon: Search },
    { id: 'mail-templates' as const, title: 'Choisissez le modèle de mail à envoyer aux SCI', icon: Mail },
  ]), []);

  return (
    <div className="rounded-lg bg-white p-8 shadow-md">
      <div className="sticky top-5 z-20 mx-5 mt-6">
        <div className="grid grid-cols-1 overflow-hidden rounded-2xl border border-gray-200/80 bg-gray-100 md:grid-cols-2">
          {tabs.map(step => {
            const isActive = activeTab === step.id;
            return (
              <button
                key={step.id}
                onClick={() => setActiveTab(step.id)}
                className={`flex min-h-24 cursor-pointer flex-col items-center justify-center gap-2 px-6 py-5 transition-all duration-300 hover:-translate-y-0.5 ${
                  isActive
                    ? 'border-b-4 border-blue-600 bg-white font-bold text-slate-800 shadow'
                    : 'border-b-4 border-transparent bg-transparent font-semibold text-slate-500'
                }`}
              >
                <step.icon className="h-6 w-6" />
                <span className="text-center leading-relaxed">{step.title}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="px-5 py-8 pb-15">
        {activeTab === 'identify' && (
          <SCIsOverall />
        )}
        {activeTab === 'mail-templates' && (
          <SciMailTemplates
            mailTemplates={rentMailTemplates}
            onBackToSelection={() => setActiveTab('identify')}
            backButtonText="← Retour à la liste des SCI"
            companyDefaultId={companyDefaultId}
          />
        )}
      </div>
    </div>
  );
}

export default SCIsRent;


